import { dashboardStatsSchema, DashboardStats } from '../models/DashboardStats';
import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { API_ATTEND_TRACK_URL } from '@/utils/servers';
import {
  attentionUsersResponseSchema,
  AttentionUsersResponse,
} from '../models/AttentionUser';

export interface DashboardFiltersParams {
  dateFrom?: string;
  dateTo?: string;
  sectorId?: string;
  attentionUserId?: string;
}

const dashboardService = createApi({
  reducerPath: 'dashboardService',
  baseQuery: createBaseQueryWithReauth(API_ATTEND_TRACK_URL),
  tagTypes: ['DashboardStats', 'AttentionUsers'],
  endpoints: (builder) => ({
    getDashboardStats: builder.query<DashboardStats, DashboardFiltersParams>({
      query: (params) => ({
        url: '/statistics/dashboard',
        params,
      }),
      transformResponse: (response: unknown) => {
        const parsed = dashboardStatsSchema.parse(response);
        return parsed;
      },
      providesTags: ['DashboardStats'],
    }),
    getAttentionUsers: builder.query<
      AttentionUsersResponse,
      string | undefined
    >({
      query: (search) => ({
        url: '/inbox/attention-users',
        params: search ? { search } : undefined,
      }),
      transformResponse: (response: unknown) => {
        return attentionUsersResponseSchema.parse(response);
      },
      providesTags: ['AttentionUsers'],
    }),
  }),
});

export const {
  useGetDashboardStatsQuery,
  useLazyGetDashboardStatsQuery,
  useGetAttentionUsersQuery,
} = dashboardService;

export default dashboardService;
